/**
 * Per-day shift override (employee selects shift before check-in when policy allows).
 */

import { getLocalDayKey } from "./attendancePunchStorage";

const SHIFTS_STORAGE_KEY = "hrms_frontend_attendance_shifts_v1";

function loadShiftsLocal() {
  try {
    const raw = localStorage.getItem(SHIFTS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export const SHIFT_OVERRIDE_STORAGE_KEY = "hrms_attendance_shift_override_v1";
export const SHIFT_OVERRIDE_UPDATED_EVENT = "hrms-attendance-shift-override-updated";

function loadAll() {
  try {
    const raw = localStorage.getItem(SHIFT_OVERRIDE_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveAll(rows) {
  localStorage.setItem(SHIFT_OVERRIDE_STORAGE_KEY, JSON.stringify(rows));
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SHIFT_OVERRIDE_UPDATED_EVENT));
  }
}

export function getShiftOverrideForDay(employeeId, dayKey = getLocalDayKey()) {
  const id = String(employeeId ?? "");
  if (!id) return null;
  const row = loadAll().find(
    (r) => String(r.employeeId) === id && r.dayKey === dayKey
  );
  if (!row) return null;
  const shifts = loadShiftsLocal();
  const shift =
    shifts.find((s) => String(s.id) === String(row.shiftId)) ||
    shifts.find(
      (s) =>
        String(s.name || "").toLowerCase() ===
        String(row.shiftName || "").toLowerCase()
    );
  return shift ? { ...row, shift } : row;
}

export function setShiftOverrideForDay(employeeId, shiftId, shiftName, dayKey = getLocalDayKey()) {
  const id = String(employeeId ?? "");
  if (!id || !shiftId) return null;
  const next = loadAll().filter(
    (r) => !(String(r.employeeId) === id && r.dayKey === dayKey)
  );
  const entry = {
    employeeId: id,
    dayKey,
    shiftId: String(shiftId),
    shiftName: shiftName || "",
    setAt: Date.now(),
  };
  next.push(entry);
  saveAll(next);
  return entry;
}

export function clearShiftOverrideForDay(employeeId, dayKey = getLocalDayKey()) {
  const id = String(employeeId ?? "");
  saveAll(
    loadAll().filter((r) => !(String(r.employeeId) === id && r.dayKey === dayKey))
  );
}

export function listShiftOverridesForEmployee(employeeId) {
  return loadAll().filter((r) => String(r.employeeId) === String(employeeId));
}
